import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { MixpanelDiscoveryService } from '@services/mixpanel/discovery/mixpanel-discovery.service';
import { TrialService } from '@services/trial/trial.service';

@Component({
    selector: 'app-guided-trial-resume',
    imports: [TranslateModule],
    templateUrl: './guided-trial-resume.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './guided-trial-resume.component.scss'
})
export class GuidedTrialResumeComponent {
    private discoveryService = inject(MixpanelDiscoveryService);
    private trialService = inject(TrialService);
    private router = inject(Router);

    isTrialActive = this.trialService.isTrialActive;
    resume = this.discoveryService.pendingResume;
    activeStep = this.discoveryService.activeStep;

    returnToGuide(): void {
        const target = this.resume();
        if (target) this.router.navigateByUrl(target.returnUrl);
    }

    dismissResume(): void {
        this.discoveryService.pendingResume.set(null);
    }
}
